<template>
  <AppShell>
    <section class="miss">
      <p class="code">404</p>
      <h1>页面不存在</h1>
      <p class="sub">没有这个地址。链接可能写错了，或者页面已经移走。</p>
      <p class="path">{{ path }}</p>
      <div class="actions">
        <router-link to="/" class="primary">去查参数</router-link>
        <router-link to="/forum" class="ghost">去论坛</router-link>
      </div>
    </section>
  </AppShell>
</template>

<script>
import AppShell from '../layouts/AppShell.vue'

export default {
  name: 'NotFound',
  components: { AppShell },
  computed: {
    path() {
      return this.$route.fullPath || '/'
    }
  }
}
</script>

<style scoped>
.miss {
  max-width: 520px;
  margin: 48px auto 0;
  padding: 36px 28px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 20px;
  text-align: center;
}
.code {
  margin: 0;
  font-size: 64px;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1;
  color: #165dff;
}
h1 {
  margin: 12px 0 8px;
  font-size: 28px;
  font-weight: 650;
  letter-spacing: -0.03em;
}
.sub {
  margin: 0;
  color: #4e5969;
  font-size: 15px;
  line-height: 1.6;
}
.path {
  margin: 14px 0 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: #f7f8fa;
  color: #86909c;
  font-size: 13px;
  word-break: break-all;
}
.actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 22px;
}
.primary,
.ghost {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 14px;
  border-radius: 12px;
  font-size: 14px;
  text-decoration: none;
}
.primary {
  background: #165dff;
  color: #fff;
}
.ghost {
  background: #fff;
  color: #4e5969;
  border: 1px solid #e5e6eb;
}
</style>
